import { formatDate, formatVkLink } from '../utils/formatUtils';

const PostMeta = ({ post }) => {

return (
<div className="source-data-post-meta">
<span>📅 {formatDate(post.date)}</span>
<span>👍 {post.likes?.count || 0}</span>
<span>👀 {post.views?.count || 0}</span>
<span>💬 {post.comments_count || 0}</span>
<a href={formatVkLink(post.from_id)} target="_blank" rel="noopener noreferrer">Автор</a>
<a href={`https://vk.com/wall${post.group_id}_${post.id}`} target="_blank" rel="noopener noreferrer">Пост</a>
</div>
)}

export default PostMeta;